import { ReactComponent as TagImage } from "../images/tag.svg";

const Tag = ({ children }) => {
    return(
        <div className="tag">
            <span className="tag-icon"><TagImage /></span>
            <span className="tag-label">{children}</span>
        </div>
    )
}

export default Tag;